import { useRef, useState } from "react";
import { http, errMsg } from "./api";
import { AIProgress } from "../components/kit/AIProgress";

const norm = (d, title) => ({ ...d, title, steps: (d.steps || []).map((m) => (typeof m === "string" ? { msg: m } : m)) });

// Barra única con % real: el backend reporta avance por X-Op-Id en /api/ops/{id}
export const useOp = (testid = "op-progress") => {
  const [job, setJob] = useState(null);
  const timer = useRef(null);
  const poll = (id, title, bg) => new Promise((resolve) => {
    timer.current = setInterval(async () => {
      const r = await http.get(`/ops/${id}`).catch(() => null);
      if (!r || r.data.status === "queued") return;
      setJob(norm(r.data, title));
      if (bg && !["running"].includes(r.data.status)) { clearInterval(timer.current); resolve(r.data); }
    }, 600);
  });
  const run = async (title, fn, { background = false } = {}) => {
    const id = crypto.randomUUID();
    setJob({ status: "running", progress: 1, message: "Iniciando…", steps: [], created_at: new Date().toISOString(), title });
    const fin = poll(id, title, background);
    try {
      const res = await fn({ headers: { "X-Op-Id": id, "X-Op-Title": encodeURIComponent(title) } });
      if (background) await fin;
      clearInterval(timer.current);
      const r = await http.get(`/ops/${id}`).catch(() => null);
      setJob(norm({ ...(r?.data || {}), status: r?.data?.status === "error" ? "error" : "done", progress: 100 }, title));
      return res;
    } catch (e) {
      clearInterval(timer.current);
      setJob((j) => ({ ...j, status: "error", message: errMsg(e) }));
      throw e;
    }
  };
  const bar = job ? <AIProgress job={job} title={job.title} compact testid={testid} /> : null;
  return { run, bar, job, busy: job?.status === "running" };
};

export { saveBlob } from "./api";
